__turbopack_context__.v({
  "logoutIcon": "LogoutButton-module__J07kLW__logoutIcon",
  "navLink": "LogoutButton-module__J07kLW__navLink",
});
